export async function sendMessage(json){
    const payload = {...json, requestType: "inquiry", subject: "New Inquiry from tyesims.com"};
    try {
        const response = await fetch(process.env.REACT_APP_MAILER_URL ?? 'https://pl4y-middle-earth.click/v1/mailer', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-tenant-id": process.env.REACT_APP_TENANT_ID ?? 'cyy5sqi3at',
            },
            body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (!response.ok) {
            console.error("Mailer error:", data);
            return;
        }

        console.log('Success!')
    return data;
    } catch (err) {
        console.error("Network or JSON error:", err);
    }
}